export default __webpack_public_path__ + "static/media/at-transparent.7f14fecd.png";